/**
 * @generated SignedSource<<bf5b6def5879dbdb238a1520499a8501>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SwitchAppForSessionPayload",
    "kind": "LinkedField",
    "name": "switchAppForSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsModalQuery_switchAppMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsModalQuery_switchAppMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0e201139bf6f264589297ed4aa3c3f51",
    "id": null,
    "metadata": {},
    "name": "SettingsModalQuery_switchAppMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsModalQuery_switchAppMutation(\n  $input: SwitchAppForSessionInput!\n) {\n  switchAppForSession(input: $input) {\n    ok\n    error {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7d58bea6989aea52ec33a88177fd329a";

module.exports = node;
